var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImagePickerRaw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 97"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.32327 3.02078C6.8158 2.83569 5.44372 3.90768 5.25862 5.41514L5 7.52145H6.51126L6.74744 5.59795C6.83157 4.91274 7.45525 4.42547 8.14046 4.5096L20.051 5.97203C20.7362 6.05616 21.2235 6.67984 21.1394 7.36505L20.1644 15.3054C20.0803 15.9906 19.4566 16.4779 18.7714 16.3938L18.2468 16.3294V17.5215C18.2468 17.629 18.2383 17.7346 18.2219 17.8376L18.5886 17.8826C20.096 18.0677 21.4681 16.9957 21.6532 15.4882L22.6282 7.54785C22.8133 6.04039 21.7413 4.66831 20.2338 4.48321L8.32327 3.02078Z",
    fill: "#2B323B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 9C2 7.89543 2.89543 7 4 7H16C17.1046 7 18 7.89543 18 9V18C18 19.1046 17.1046 20 16 20H4C2.89543 20 2 19.1046 2 18V9Z",
    stroke: "#2B323B",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 1",
    d: "M2 15.9L5.19142 13.4887C5.95225 12.9139 7.01311 12.9561 7.72582 13.5896L9.86601 15.492C10.5365 16.088 11.5217 16.1646 12.2763 15.6795L18 12",
    stroke: "#2B323B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 59",
    cx: 12,
    cy: 11,
    r: 1.35,
    stroke: "#2B323B",
    strokeWidth: 1.3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImagePickerRaw);
export default __webpack_public_path__ + "static/media/imagePickerRaw.7cbdaeaacf20d4637f907144fdcd507a.svg";
export { ForwardRef as ReactComponent };